import _ from 'lodash';
import React, { useState, useEffect } from 'react';
import { graphql } from 'gatsby';
import Layout from "../components/layout";
import Breadcrumb from '../components/breadcrumb';
import Headtohead from '../components/headtohead';
import Gamelogs from '../components/gamelogs';

const HeadToHead = (query) => {
    // Get GraphlQL data
	const games = query.data.allGamesJson.nodes;
    const teams = query.data.allOwnersJson.nodes;

    const initialTeam = {
        record: '-',
        name: '',
        image: 'https://fantasy-franchise.com/img/DEF.png',
        currentstreak: 0,
        highestwinstreak: 0,
        totalPoints: 0,
        highestScore: 0,
        lowestScore: 0,
        highestMargin: 0,
        lowestMargin: 0
    };

    const [teamAId, setTeamAId] = useState();
    const [teamBId, setTeamBId] = useState();
    const [playedGames, setPlayedGames] = useState();
    const [teamA, setTeamA] = useState(initialTeam);
    const [teamB, setTeamB] = useState(initialTeam);
    const [isMatch, setIsMatch] = useState(false);

    const teamChange = (e) => {
        e.persist();
        if (e &&  e.target && e.target.name === 'teama') {
            setTeamAId(() => e.target.value );
        }
        else if (e &&  e.target) {
            setTeamBId(() => e.target.value);
        }
    };

    const setTeams = (games,teamId) => {
        return games.reduce((acc, game) => {
            const teamA = game?.team_a[0];
            const teamB = game?.team_b[0];
            const teamHomeWin = game.winner === 'HOME' && teamA.ownerId === teamId;
            const teamHomeLose = game.winner === 'AWAY' && teamA.ownerId === teamId;
            const teamAwayWin = game.winner === 'AWAY' && teamB.ownerId === teamId;
            const teamAwayLose = game.winner === 'HOME' && teamB.ownerId === teamId;
            const marginTeamA = teamA.score - teamB.score;
            const marginTeamB = teamB.score - teamA.score;

            if (teamHomeWin || teamAwayWin ) {
                acc.record++;
                acc.currentstreak++;
                if (acc.highestwinstreak < acc.currentstreak) {
                    acc.highestwinstreak = acc.currentstreak;
                }

                if (teamA.ownerId === teamId) {
                    acc.highestMargin = (acc.highestMargin > (marginTeamA)) ? acc.highestMargin : (marginTeamA);
                    acc.lowestMargin = (acc.lowestMargin < (marginTeamA) && acc.lowestMargin > 0) ? acc.lowestMargin : (marginTeamA);
                }
                else if (teamB.ownerId === teamId) {
                    acc.highestMargin = (acc.highestMargin > (marginTeamB)) ? acc.highestMargin : (marginTeamB);
                    acc.lowestMargin = (acc.lowestMargin < (marginTeamB) && acc.lowestMargin > 0) ? acc.lowestMargin : (marginTeamB);
                }
            }

            if (teamHomeLose || teamAwayLose ) {
                acc.currentstreak = 0;
            }
            
            if (teamA.ownerId === teamId) {
                acc.totalPoints = parseFloat(acc.totalPoints + teamA.score);
                acc.highestScore = (acc.highestScore > teamA.score) ? acc.highestScore : teamA.score;
                acc.lowestScore = (acc.lowestScore < teamA.score && acc.lowestScore > 0) ? acc.lowestScore : teamA.score
            }
            else if (teamB.ownerId === teamId) {
                acc.totalPoints = parseFloat(acc.totalPoints + teamB.score);
                acc.highestScore = (acc.highestScore > teamB.score) ? acc.highestScore : teamB.score;
                acc.lowestScore = (acc.lowestScore < teamB.score && acc.lowestScore > 0) ? acc.lowestScore : teamB.score 
            }

            return acc;
            }, {
                record: 0,
                name: _.find(teams, ['id', teamId])?.name,
                image: _.find(teams, ['id', teamId])?.image,
                currentstreak: 0,
                highestwinstreak: 0,
                totalPoints: 0,
                highestScore: 0,
                lowestScore: 0,
                highestMargin: 0,
                lowestMargin: 0
        });
    }

    useEffect(() => {
        let filteredGames = games;
        if (teamAId) {
            filteredGames = filteredGames.filter(function (game) {
                return game.team_a[0]?.ownerId === teamAId || game.team_b[0]?.ownerId === teamAId ;
            });   

            setTeamA ( () => setTeams(filteredGames,teamAId));
        }

        if (teamBId) {
            filteredGames = filteredGames.filter(function (game) {
                return game.team_a[0]?.ownerId === teamBId || game.team_b[0]?.ownerId === teamBId ;
            });   

            setTeamB ( () => setTeams(filteredGames,teamBId));
        }

        if (teamAId && teamBId && teamAId !== teamBId && filteredGames) {
            console.log(filteredGames,"esto es filtered ")
            setIsMatch(() => true);
            setPlayedGames(() => filteredGames.reverse());
        }
        else {
            setIsMatch(() => false);
        }
	}, [teamAId,teamBId,games]);

    return (
        <Layout >
        <main className="container-fluid headtohead">
            <Breadcrumb title="Head to Head" />

            <div className="row">
                <div className="col-lg-7">
                    <Headtohead
                        owners={teams}
                        teamSelect={(e) => { teamChange(e); }} 
                        teama={teamA}
                        teamb={teamB}
                        isMatch={isMatch}
                    />
                </div>
                {
                <div className="col-lg-5">
                    <Gamelogs data={playedGames} />
                </div> 
                }
            </div>
        </main>
        </Layout>
    );

}

export default HeadToHead;

export const pageQuery = graphql`
{
  allGamesJson {
    nodes {
      id
      year
      winner
      week
      playoffTierType
      team_a {
        logo
        name
        owner
        ownerId
        rank
        score
      }
      team_b {
        logo
        name
        owner
        ownerId
        rank
        score
      } 
    }
  }
  allOwnersJson {
    nodes {
      fantasyname
      id
      image
      name
      status
    }
  }
}
`;